/**
 * True when the map Stimulus controller (map--maps) owns filter-change refetches.
 * Legacy search_results initMap has no maps controller; flexmls_map still handles those.
 */
export function filterChangesCoordinatedByMapsController() {
  const mapContainer = document.getElementById('mapContainer');
  if (!mapContainer) {
    return false;
  }
  const controllers = mapContainer.getAttribute('data-controller') || '';
  return controllers.split(/\s+/).includes('map--maps');
}
